import './WelcomeMessage.scss'

import { RightCircleFilled } from '@ant-design/icons'
import { Button } from 'antd'
import SelectBranchModal from 'components/select-branch-modal/SelectBranchModal'
import { useHesapBilgilerimQuery } from 'gql/GeneratedGraphqlTypes'
import React, { useState } from 'react'

import arrow from './Arrow.png'
interface Props {
  onClassSelected: (selectedClassId: number) => void
  sezon?: string
  hasKiyafet?: boolean
  hasKitap?: boolean
}
const WelcomeMessage: React.FC<Props> = ({ onClassSelected, sezon, hasKiyafet, hasKitap }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const { data: hesapData } = useHesapBilgilerimQuery()
  const isim = hesapData?.profil?.isim
  const soyisim = hesapData?.profil?.soyisim
  const veliAdi = isim && soyisim ? `${isim} ${soyisim}` : isim ?? 'Veli'

  let urunMetni: string
  if (hasKiyafet && hasKitap) {
    urunMetni = 'tüm kitap, kırtasiye ve okul kıyafeti'
  } else if (hasKiyafet) {
    urunMetni = 'okul kıyafeti'
  } else if (hasKitap) {
    urunMetni = 'kitap, kırtasiye'
  } else {
    urunMetni = 'tüm'
  }

  return (
    <div className="welcome-message">
      <div className="welcome-message-content">
        <h3>Hoş geldiniz, Sayın {veliAdi}! 🌟 </h3>
        <span className="welcome-message-text">
            {sezon ? `${sezon} ` : ''}eğitim ve öğretim yılı {urunMetni} ihtiyaçlarınızı
          okulunuza özel hazırlanmış olan internet sitemizden hemen satın alabilirsiniz.
        </span>
      </div>
      <img src={arrow} alt="arrow" className="arrow-image" />
      <div className="welcome-message-content class-list">
        <span className="class-list-span">Sınıf Listesine ulaşmak için tıklayın </span>
        <Button 
           onClick={() => {
            setModalOpen(true)
          }}
        icon={<RightCircleFilled />}>Okul ve Sınıf Seç </Button>
      </div>

      <SelectBranchModal onClassSelected={onClassSelected} modalOpen={modalOpen} setModalOpen={setModalOpen} />
    </div>
  )
}

export default WelcomeMessage
